import supportFA from './fa/fa.json'

const SupportMessages = {
  fa: { ...supportFA },
}

export default SupportMessages
